import { Card, Divider, Stack } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { useLinkConfig } from "../hooks";
import { Loader, LoadingButton } from "../../../shared";
import { TenantInfoText } from "../components";

export const LinksConfig = () => {
  const { formValidator, state, onChange, onSubmit } = useLinkConfig();
  const { formData } = state;

  const validations = {
    privacy_policy: formValidator.current.message(
      "Privacy Policy URL",
      formData.privacy_policy,
      "url",
    ),
    terms_of_service: formValidator.current.message(
      "Terms of Service URL",
      formData.terms_of_service,
      "url",
    ),
    refund_policy: formValidator.current.message(
      "Refund Policy URL",
      formData.refund_policy,
      "url",
    ),
    help_center: formValidator.current.message(
      "Help URL",
      formData.help_center,
      "url",
    ),
  };

  return (
    <Card
      sx={{ p: "24px", gap: "20px", display: "flex", flexDirection: "column" }}
    >
      <TenantInfoText infoKey="linkConfig" alert />

      {state.isLoading ? (
        <Stack height="330.8px" justifyContent="center" alignItems="center">
          <Loader />
        </Stack>
      ) : (
        <>
          <InputControl
            name="privacy_policy"
            label="Privacy Policy URL"
            placeholder="https://google.com"
            value={formData.privacy_policy}
            onChange={onChange}
            error={!!validations.privacy_policy}
            helperText={validations.privacy_policy}
          />
          <InputControl
            name="terms_of_service"
            label="Terms of Service URL"
            placeholder="https://google.com"
            value={formData.terms_of_service}
            onChange={onChange}
            error={!!validations.terms_of_service}
            helperText={validations.terms_of_service}
          />
          <InputControl
            name="refund_policy"
            label="Refund Policy URL"
            placeholder="No URL set - click to add policy URL"
            value={formData.refund_policy}
            onChange={onChange}
            error={!!validations.refund_policy}
            helperText={validations.refund_policy}
          />
          <InputControl
            name="help_center"
            label="Help Center URL"
            placeholder="No URL set - click to add help center URL"
            value={formData.help_center}
            onChange={onChange}
            error={!!validations.help_center}
            helperText={validations.help_center}
          />

          <Divider />
          <LoadingButton
            variant="contained"
            sx={{ ml: "auto", width: { xs: "100%", sm: "max-content" } }}
            onClick={onSubmit}
            loading={state.isSubmitting}
            disabled={!state.hasChanges}
          >
            Save
          </LoadingButton>
        </>
      )}
    </Card>
  );
};
